export interface CartFavoritesTracking {
  name?: string;
  rule?: string;
  currency: string;
  variant?: string;
  decisionId?: string;
  pbEventContext?: string;
}

const DEFAULT_TRACKING_NAME = 'wishlist_items';
const DEFAULT_TRACKING_RULE = 'last_wishlist_adds';
const DEFAULT_CURRENCY = 'EUR';
const DEFAULT_PB_EVENT_CONTEXT = 'abtest-ents-t7180-favoriten-reco-warenkorb';

export const defaultTracking = (): CartFavoritesTracking => ({
  name: DEFAULT_TRACKING_NAME,
  rule: DEFAULT_TRACKING_RULE,
  currency: DEFAULT_CURRENCY,
  decisionId: '',
  pbEventContext: DEFAULT_PB_EVENT_CONTEXT,
});

export const trackingWithDefaults = (tracking?: Partial<CartFavoritesTracking>): CartFavoritesTracking => ({
  name: tracking?.name ?? DEFAULT_TRACKING_NAME,
  rule: tracking?.rule ?? DEFAULT_TRACKING_RULE,
  currency: tracking?.currency ?? DEFAULT_CURRENCY,
  variant: tracking?.variant,
  decisionId: tracking?.decisionId ?? '',
  pbEventContext: tracking?.pbEventContext ?? DEFAULT_PB_EVENT_CONTEXT,
});
